export default "__VITE_ASSET__CpL_Cdza__"